import { createStore } from "vuex";
import axios from 'axios'

export default createStore({
  state: {
    players: [],
    sponsor: [],
    albums: [],
    album: {},
    form: {
      username: '',
      phone: '',
      email: '',
      address: '',
      idcard: '',
      birthdate: '',
      weight: '',
      height: '',
      ftp: '',
    },
  },
  getters: {
    getThird(state) { // 用 getters 計算 players 的 "third" 總共有幾個，在傳回去給選手名單的 rowspan 用
      return state.players[0].second.length * state.players[0].second[0].third.length
    }
  },
  mutations: {
    setPlayers(state, payload) {
      state.players = payload;
    },
    setSponsor(state, payload) {
      state.sponsor = payload;
    },
    setForm(state, payload) {
      state.form = payload;
    },
    setAlbums(state, payload) {
      state.albums = payload;
    },
    setAlbum(state, payload) {
      state.album = payload;
    },
    resetForm(state) {
      Object.keys(state.form).forEach(key => {
          state.form[key] = ''
      });
    }
  },
  actions: {
    getPlayers(context) {
      fetch('./static/json/players.json')
      .then(rs => rs.json())
      .then(res => {
        console.log('vuex players', res)
        context.commit('setPlayers', res)
      })
    },

    getSponsor(context) {
      fetch('./static/json/sponsor.json')
      .then(rs => rs.json())
      .then(res => {
        console.log('vuex sponsor', res)
        context.commit('setSponsor', res)
      })
    },

    getAlbums(context, id) { 
      fetch('./static/json/album.json')
      .then(rs => rs.json())
      .then(res => {
        console.log('vuex album', res)
        if(!id) { // 取得全部相簿
          context.commit('setAlbums', res)
        } else {
          const thisAlbum = res.find(item => item.id == id)
          context.commit('setAlbum', thisAlbum)
        }
        
      })
    },

    playerApply(context, item) {
      const url = `https://eventapi.ttelgaming.com.tw/ajax_ttbikecomp.php`;
      // const datas = { ...item }
      console.log('vuex item', item)

      // 用一般的 json 格式無法送過去，只能用 form data
      const formData = new FormData(); // 然後轉成 form data 格式
      formData.append('username', item.username)
      formData.append('phone', item.phone)
      formData.append('email', item.email)
      formData.append('address', item.address)
      formData.append('idcard', item.idcard)
      formData.append('birthdate', item.birthdate)
      formData.append('weight', item.weight)
      formData.append('height', item.height)
      formData.append('ftp', item.ftp)

      axios.post(url, formData)
      .then(res => {
        console.log('報名', res, 'form 資料', this.state.form)
        if(res.data.result) {
          alert('報名資料已送出！\n恭喜您！已完成初步報名作業程序，請靜候「TT曜越單車電競爭霸戰」賽事單位的審核與抽選分組，並於10/12(三) 16:00前往賽事網頁確認最終賽事名單。')
        } else {
          alert(`報名失敗：${res.data.msg}`)
        }
        
        context.commit('resetForm') // 清空 form
      })
    }
  },
  modules: {},
});
